import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ModalService } from './modal.service';
import { AddCartRequest } from '../interfaces/add-cart-request.interface';
import { catchError, map, Observable, of, switchMap, tap } from 'rxjs';
import { GetCartResponse } from '../interfaces/get-cart-response.interface';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class CartService {
  private http = inject(HttpClient);
  private modalService = inject(ModalService);

  #cartUrl = `${API_URL}/carts`;

  addCart(detailCatalogId: string, quantity = 1): Observable<boolean> {
    const request: AddCartRequest = {
      quantity,
      detailCatalogId,
      updateQuantity: false,
    };
    return this.http.put(`${this.#cartUrl}/add`, request).pipe(
      map(() => {
        this.modalService.addArticleSuccess();
        return true;
      }),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      })
    );
  }

  updateCart(detailCatalogId: string, quantity: number): Observable<boolean> {
    const request: AddCartRequest = {
      quantity,
      detailCatalogId,
      updateQuantity: true,
    };
    return this.http.put(`${this.#cartUrl}/add`, request).pipe(
      map(() => {
        this.modalService.openGenericModal({
          title: '¡ARTÍCULO ACTUALIZADO EXITOSAMENTE!',
        });
        return true;
      }),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      })
    );
  }

  removeCart(detailCatalogId: string): Observable<boolean> {
    return this.http
      .put(`${this.#cartUrl}/remove`, {
        detailCatalogId,
      })
      .pipe(
        map(() => {
          this.modalService.openGenericModal({
            title: '¡ARTÍCULO ELIMINADO EXITOSAMENTE!',
          });
          return true;
        }),
        catchError((err: HttpErrorResponse) => {
          this.modalService.showErrorModal(err);
          return of(false);
        })
      );
  }

  getCart(): Observable<GetCartResponse> {
    return this.http.get<GetCartResponse>(`${this.#cartUrl}`);
  }

  addCartRecomedation(detailCatalogId: string, quantity = 1): Observable<boolean> {
    const request: AddCartRequest = {
      quantity,
      detailCatalogId,
      updateQuantity: false,
    };
    return this.http.put(`${this.#cartUrl}/add`, request).pipe(
      map(() => {
        return true;
      }),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      })
    );
  }
}
